import { useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import EditableText from '../../../../ui/EditableText/EditableText'
import css from './TaskModalTitle.module.css'

export interface TaskModalTitleHandle {
    startEditing: () => void
}

interface TaskModalTitleProps {
    name: string
    onSave: (name: string) => Promise<void>
}

const TaskModalTitle = forwardRef<TaskModalTitleHandle, TaskModalTitleProps>(({ name, onSave }, ref) => {
    const [isEditing, setIsEditing] = useState(false)
    const [value, setValue] = useState('')

    useEffect(() => {
        setValue(name)
    }, [name])

    const handleStartEditing = () => {
        setValue(name)
        setIsEditing(true)
    }

    useImperativeHandle(ref, () => ({ startEditing: handleStartEditing }))

    const handleSave = async () => {
        setIsEditing(false)
        if (value.trim() !== '' && value !== name) {
            await onSave(value.trim())
        }
    }

    const isEmpty = !value || value.trim() === ''

    return (
        <div className={css.title}>
            <EditableText
                wrap={true}
                isEditing={isEditing}
                text={isEmpty && !isEditing ? 'Untitled' : value}
                onChange={(v) => setValue(v.replace(/->/g, '→'))}
                onBlur={handleSave}
                onStartEditing={handleStartEditing}
            />
        </div>
    )
})

export default TaskModalTitle
